import { type Status, VALID_STATUSES } from '../searchControls';

export const isValidStatus = (status: string | null): status is Status => {
  return status !== null && VALID_STATUSES.includes(status as Status);
};
